import Axios from 'axios';


let axios = Axios.create({
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
});
export const postAxios = (url, data) => {
    return axios.post(url, data);
};

export const postFileUploadAxios = (url, data) => {
    return axios.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const getDownloadAxios = (url) => {
    return axios.get(url, { responseType: 'blob' });
};

export const postDownloadAxios = (url, data) => {
    return axios.post(url, data, { responseType: 'blob' });
};

export const getAxios = (url, data) => {
    return axios.get(url, {
        params: data
    });
};

function download (res) {
    let reader = new FileReader();
    let data = res.data;
    reader.onload = e => {
        if (e.target.result.indexOf('Result') != -1 && JSON.parse(e.target.result).Result == false) {
            // 进行错误处理
        } else {
            let fileName = "download";
            let contentDisposition = res.headers['Content-Disposition'];
            contentDisposition = contentDisposition ? contentDisposition : res.headers['content-disposition'];
            if (contentDisposition) {
                fileName = window.decodeURI(contentDisposition.split('=')[1], "UTF-8");
            }
            executeDownload(data, fileName);
        }
    };
    reader.readAsText(data);
}

//  模拟点击a 标签进行下载
function executeDownload (data, fileName) {
    if (!data) {
        return
    }
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
